import React, { useState } from "react";
import { useSearchBox } from "react-instantsearch";
import { Configure } from "react-instantsearch";

function CustomSearchBox() {
    const { refine } = useSearchBox();

    const [query, setQuery] = useState("");
    const [exact, setExact] = useState(false);

    return (
        <div>
            <input
                type="text"
                className="form-control mb-2"
                placeholder="Rechercher..."
                value={query}
                onChange={(e) => {
                    const value = e.target.value;
                    setQuery(value);
                    refine(value);
                }}
            />

            <label className="form-check">
                <input
                    type="checkbox"
                    className="form-check-input"
                    checked={exact}
                    onChange={(e) => setExact(e.target.checked)}
                />
                <span className="form-check-label">
                    Recherche exacte
                </span>
            </label>

            {/* 🔥 LA VRAIE SOLUTION */}
            {exact && query && (
                <Configure filters={`terme_m:"${query}"`} />
            )}
        </div>
    );
}

export default CustomSearchBox;